export default __webpack_public_path__ + "static/media/cloudnetwork.68cc91d2.svg";